import { useState } from 'react';
import styles from './Header.module.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCookies } from 'react-cookie';

export function Header() {
    const navigate = useNavigate();
    const [cookie] = useCookies();
    return <div className={styles.headerBackground}>
        <img src="/images/white/logo/rjitube.svg" alt="logo" className={styles.headerLogo} onClick={() => {navigate("/")}}/>
        <SearchForm />
        {/* {cookie["token"]? <Account />: <button className={styles.headerLoginBtn} onClick={()=>{navigate("/signin")}}>Войти</button>} */}
    </div>
}

function Account({ avatar, notificationsCount }) {
    const [submenuOpened, setSubmenuOpened] = useState(false);
    function onImageClickHandler() {
        setSubmenuOpened((s)=>!s);
    }
    return <>
        <div className={styles.accountPlace} onClick={onImageClickHandler}>
            <img src={avatar? avatar: "/images/white/account/avatar.jpg"} alt="account-image" className={styles.accountImage} />
            {notificationsCount > 0 && <p className={styles.notificationsCountOverlay}>{notificationsCount}</p>}
        </div>
        {submenuOpened && <AccountMenu />}
    </>
}

function SearchForm() {
    const navigate = useNavigate();
    const searchParams = useSearchParams()[0];
    const query = searchParams.get("query");
    const [searchField, setSearchField] = useState(query === null ? "" : query);

    function onSubmitSearch(e) {
        e.preventDefault();
        if (searchField.trim() !== "") {
            navigate(`/search?query=${searchField}`);
        }
    }

    return (
        <form className={styles.searchForm} onSubmit={onSubmitSearch}>
            <input
                type="text"
                className={styles.searchField}
                name="query"
                value={searchField}
                onChange={(e) => setSearchField(e.target.value)}
                placeholder="Искать где-то..."
                size="1"
            />
            <button type="submit" className={styles.searchButton}>
                <img
                    alt="search"
                    className={styles.searchButtonIcon}
                    src={"/images/white/header/search.svg"}
                />
            </button>
        </form>
    );
}

function AccountMenu() {
    const navigate = useNavigate();
    return <div className={styles.accountMenu}>
        <MenuElement icon={"/images/white/header/account-dropdown/account.svg"}
            name={"Мой канал"} isNext={true}
            onClick={() => {navigate("/account")}} />
        <MenuElement icon={"/images/white/header/account-dropdown/settings.svg"}
            name={"Настройки"} isNext={true}
            onClick={() => {navigate("/settings")}} />
        <MenuElement icon={"/images/white/header/account-dropdown/admin.svg"}
            name={"Админ панель"} isNext={true}
            onClick={() => {navigate("/admin")}} />
        <MenuElement icon={"/images/white/header/account-dropdown/contact.svg"}
            name={"Связаться с нами"} isNext={true}
            onClick={() => {navigate("/contact")}} />
        <MenuElement icon={"/images/white/header/account-dropdown/logout.svg"}
            name={"Выйти из аккаунта"} isNext={true} className={styles.redMenuElement}
            onClick={() => {navigate("/logout")}}/>
    </div>
}

function MenuElement({icon, name, isNext, onClick, className}) {
    return <div className={`${styles.menuElement} ${className || ""}`} onClick={onClick}>
        <div>
            <img className={styles.menuElementIcon} src={icon} alt={name} />
        </div>
        <p className={styles.menuElementTitle}>{name}</p>
        {isNext && <div>
            <img className={styles.menuElementNext} alt="next" src={"/images/white/header/account-dropdown/next.svg"} />
        </div>}
    </div>
}